





































































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class Loader extends Vue {
  @Prop({
    default: "#3d71e3",
  })
  primaryColor;

  @Prop({
    default: "25",
  })
  height;
}
